module.exports = __webpack_public_path__ + "static/media/pizza-logo-white.9d4e9c6f.png";